import axios from "axios";
import { apiBaseUrl } from "@/apis/appconst";

// ================================
// CUSTOMER + PLAN APIS (FormData-based)
// Controller: Cuscon.php
// ================================

// 1) Get Plans
export async function getPlans() {
  try {
    const fd = new FormData();

    const res = await axios.post(`${apiBaseUrl}cuscon/get_plans`, fd, {
      headers: { "Content-Type": "multipart/form-data" },
    });

    return res.data;
  } catch (err) {
    return { status: false, type: "danger", success: "Request Failed" };
  }
}

// 2) Get Customers (pagination + filters)
export async function getCustomers(payload) {
  try {
    const fd = new FormData();

    fd.append("page_no", payload.page_no ?? 0);
    fd.append("keyword", payload.keyword || "");
    fd.append("statusFilter", payload.statusFilter || "");
    fd.append("kycFilter", payload.kycFilter || "");
    fd.append("planFilter", payload.planFilter || "");

    const res = await axios.post(`${apiBaseUrl}cuscon/get_customers`, fd, {
      headers: { "Content-Type": "multipart/form-data" },
    });

    return res.data;
  } catch (err) {
    return { status: false, type: "danger", success: "Request Failed" };
  }
}

export async function getCustomerContacts(payload) {
  try {
    const fd = new FormData();
    fd.append("user_id", payload.user_id || "");
    fd.append("page_no", payload.page_no || "0");
    fd.append("search_key", payload.search_key || "");

    // alert("1");
    const res = await axios.post(`${apiBaseUrl}cuscon/get_customer_contact`, fd, {
      headers: { "Content-Type": "multipart/form-data" },
    });

    return res.data;
  } catch (err) {
    return { status: false, type: "danger", success: "Request Failed" };
  }
}

// 3) Add Customer
export async function addCustomer(payload) {
  try {
    const fd = new FormData();

    fd.append("name", payload.name || "");
    fd.append("email", payload.email || "");
    fd.append("phone", payload.phone || "");
    fd.append("city", payload.city || "");

    fd.append("plan_code", payload.plan_code || "FREE");
    fd.append("status", payload.status || "ACTIVE");
    fd.append("kyc", payload.kyc || "NOT_STARTED");

    fd.append("note", payload.note || "");
    fd.append("created_by", payload.created_by || "");

    const res = await axios.post(`${apiBaseUrl}cuscon/add_customer`, fd, {
      headers: { "Content-Type": "multipart/form-data" },
    });

    return res.data;
  } catch (err) {
    return { status: false, type: "danger", success: "Request Failed" };
  }
}

// 4) Update Customer Status
export async function updateCustomerStatus(user_id, status, updated_by = "") {
  try {
    const fd = new FormData();
    fd.append("user_id", user_id);
    fd.append("status", status);
    fd.append("updated_by", updated_by);

    const res = await axios.post(`${apiBaseUrl}cuscon/update_customer_status`, fd, {
      headers: { "Content-Type": "multipart/form-data" },
    });

    return res.data;
  } catch (err) {
    return { status: false, type: "danger", success: "Request Failed" };
  }
}

// 5) Update Customer KYC
export async function updateCustomerKyc(user_id, kyc_status, updated_by = "") {
  try {
    const fd = new FormData();
    fd.append("user_id", user_id);
    fd.append("kyc_status", kyc_status);
    fd.append("updated_by", updated_by);

    const res = await axios.post(`${apiBaseUrl}cuscon/update_customer_kyc`, fd, {
      headers: { "Content-Type": "multipart/form-data" },
    });

    return res.data;
  } catch (err) {
    return { status: false, type: "danger", success: "Request Failed" };
  }
}

// 6) Delete Customer
export async function deleteCustomer(user_id) {
  try {
    const fd = new FormData();
    fd.append("user_id", user_id);

    const res = await axios.post(`${apiBaseUrl}cuscon/delete_customer`, fd, {
      headers: { "Content-Type": "multipart/form-data" },
    });

    return res.data;
  } catch (err) {
    return { status: false, type: "danger", success: "Request Failed" };
  }
}

// 7) Save Note
export async function saveCustomerNote(user_id, note, created_by = "") {
  try {
    const fd = new FormData();
    fd.append("user_id", user_id);
    fd.append("note", note || "");
    fd.append("created_by", created_by);

    const res = await axios.post(`${apiBaseUrl}cuscon/save_note`, fd, {
      headers: { "Content-Type": "multipart/form-data" },
    });

    return res.data;
  } catch (err) {
    return { status: false, type: "danger", success: "Request Failed" };
  }
}

export const exportCustomersXl = async (payload) => {
  try {
    const fd = new FormData();
    fd.append("keyword", payload.keyword || "");
    fd.append("statusFilter", payload.statusFilter || "");
    fd.append("kycFilter", payload.kycFilter || "");
    fd.append("planFilter", payload.planFilter || "");

    const res = await axios.post(`${apiBaseUrl}cuscon/export_customers_xl`, fd, {
      headers: { "Content-Type": "multipart/form-data" },
      responseType: "blob",
    });

    return res.data;
  } catch (e) {
    return null;
  }
};

